let DateTimeUtil={};



//---------------------------------------------------
// 参考来源 http://blog.csdn.net/weiming8517/article/details/25604551
// 日期格式化
// 格式 YYYY/yyyy/YY/yy 表示年份
// MM/M 月份
// W/w 星期
// dd/DD/d/D 日期
// hh/HH/h/H 时间
// mm/m 分钟
// SS/S 秒
// ff/f 毫秒，未实现
//---------------------------------------------------
DateTimeUtil.toFormatString=function(date,formatStr)
{
    if(typeof date==='string')
    {
        date=new Date(date);
    }

    var str = formatStr;
    var Week = ['日','一','二','三','四','五','六'];

    str=str.replace(/yyyy|YYYY/,date.getFullYear());
    str=str.replace(/yy|YY/,(date.getYear() % 100)>9?(date.getYear() % 100).toString():'0' + (date.getYear() % 100));

    var month=date.getMonth()+1;
    str=str.replace(/MM/,month>9?month.toString():'0' + month);
    str=str.replace(/M/g,month);

    str=str.replace(/w|W/g,Week[date.getDay()]);

    str=str.replace(/dd|DD/,date.getDate()>9?date.getDate().toString():'0' + date.getDate());
    str=str.replace(/d|D/g,date.getDate());

    str=str.replace(/hh|HH/,date.getHours()>9?date.getHours().toString():'0' + date.getHours());
    str=str.replace(/h|H/g,date.getHours());
    str=str.replace(/mm/,date.getMinutes()>9?date.getMinutes().toString():'0' + date.getMinutes());
    str=str.replace(/m/g,date.getMinutes());

    str=str.replace(/ss|SS/,date.getSeconds()>9?date.getSeconds().toString():'0' + date.getSeconds());
    str=str.replace(/s|S/g,date.getSeconds());

    var ms=date.getMilliseconds();
    var msStr=ms;
    if(ms<10){
        msStr="00"+ms;
    }
    else if(ms<100){
        msStr="0"+ms;
    }
    str=str.replace(/fff|fff/,msStr);
    str=str.replace(/f|f/g,ms);

    return str;
}


DateTimeUtil.addMonth=function(date,m)
{
    var newDate=new Date(date.valueOf())
    newDate.setMonth(newDate.getMonth()+m)
    return newDate;
}


DateTimeUtil.addDate=function(date,d)
{
    var newDate=new Date(date.valueOf())
    newDate.setDate(newDate.getDate()+d)
    return newDate;
}

DateTimeUtil.getDate=function(date)
{
    var newDate=new Date(date.valueOf())
    newDate.setHours(0);
    newDate.getMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
}


DateTimeUtil.addHours=function(date,m) {
    var newDate=new Date(date.valueOf())
    newDate.setHours(newDate.getHours()+m)
    return newDate;
}

DateTimeUtil.addMinutes=function(date,m) {
    var newDate=new Date(date.valueOf())
    newDate.setMinutes(newDate.getMinutes()+m)
    return newDate;
}

DateTimeUtil.addSeconds=function(date,s)
{
    var newDate=new Date(date.valueOf())
    newDate.setSeconds(newDate.getSeconds()+s)
    return newDate;
}


DateTimeUtil.min=function() {
    let m=arguments[0];
    for (var i = 1; i < arguments.length; i++) {
        if(m>arguments[i]){
            m=arguments[i];
        }
    }
    return m;
}


DateTimeUtil.max=function() {
    let m=arguments[0];
    for (var i = 1; i < arguments.length; i++) {
        if(m<arguments[i]){
            m=arguments[i];
        }
    }
    return m;
}

//总秒数格式化，比如90秒=>01:30
//formatStr yyyy-MM-dd HH:mm:ss
DateTimeUtil.formatSeconds=function(totalSeconds,formatStr)
{

    formatStr=formatStr||'hh:mm:ss';
    let str=formatStr;
    let s=totalSeconds%60;

    let totalM=parseInt(totalSeconds/60);
    let m=totalM%60;

    let totalH=parseInt(totalM/60);
    let h=totalH%60;

    let totalD=parseInt(totalH/24);
    let d=totalH%24;

    let totalMonth=parseInt(totalD/30);
    let month=totalD%30;

    let totalY=parseInt(totalMonth/365);
    let y=totalMonth%365;

    str=str.replace('yyyy',y)
    .replace('MM',month>=10?month:`0${month}`)
    .replace('dd',d>=10?d:`0${d}`)
    .replace('hh',h>=10?h:`0${h}`)
    .replace('mm',m>=10?m:`0${m}`)
    .replace('ss',s>=10?s:`0${s}`);

    return str;
}

export default DateTimeUtil;



// WEBPACK FOOTER //
// ./src/utils/gt/DateTimeUtil.js